// allocationKeysStyles.js
import { softColors } from "../../commonColors";
import { alpha } from '@mui/material';

export const styles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    gap: 2
  },
  loadingText: {
    color: 'text.secondary',
    fontWeight: 500
  },

  headerBox: {
    p: 2.5,
    borderBottom: `1px solid ${alpha(softColors.border, 0.6)}`,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'flex-end',
    alignItems: { xs: 'stretch', md: 'center' },
    gap: 2,
    background: `linear-gradient(135deg, ${alpha('#ffffff', 0.8)} 0%, ${alpha('#f8f9fa', 0.8)} 100%)`,
    backdropFilter: 'blur(10px)'
  },

  addButtonResponsive: {
    width: { xs: '100%', md: 'auto' },
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 600,
    py: 1,
    px: 3,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    }
  },

  tableMinHeight: {
    minHeight: '300px',
    borderRadius: 2,
    overflow: 'hidden'
  },

  errorBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    py: 6,
    gap: 2
  },
  errorText: {
    fontWeight: 500
  },

  emptyBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    py: 6,
    color: 'text.secondary'
  },

  mobileCardContainer: {
    p: 2,
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },

  mobileCard: {
    p: 2.5,
    borderRadius: 3,
    overflow: 'hidden',
    border: `1px solid ${alpha(softColors.border, 0.5)}`,
    background: 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      borderColor: alpha(softColors.primary, 0.3)
    }
  },

  mobileCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  mobileCardButtonsContainer: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center'
  },

  expandButton: {
    width: '100%',
    mt: 1,
    color: softColors.primary,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.08)
    }
  },

  expandedContent: {
    mt: 2,
    p: 2,
    backgroundColor: alpha(softColors.background, 0.5),
    borderRadius: 2,
    border: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  // Footer
  footerBox: {
    p: 2,
    borderTop: `1px solid ${alpha(softColors.border, 0.6)}`,
    backgroundColor: alpha(softColors.background, 0.5)
  },

  footerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
    direction: 'rtl'
  },

  lastUpdatedText: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    color: 'text.secondary',
    fontSize: '0.875rem'
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    direction: 'rtl',
    textAlign: 'right',
    marginTop: '16px'
  },

  formLabel: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '600',
    color: '#374151',
    fontSize: '14px'
  },

  formInput: {
    width: '100%',
    padding: '12px 14px',
    border: `1px solid ${alpha('#000000', 0.12)}`,
    borderRadius: '8px',
    textAlign: 'right',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    backgroundColor: '#ffffff',
    outline: 'none'
  },

  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    marginTop: '24px',
    paddingTop: '20px',
    borderTop: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  cancelButton: {
    flex: 1,
    padding: '11px 20px',
    backgroundColor: '#ffffff',
    color: '#666666',
    border: `1px solid ${alpha('#000000', 0.12)}`,
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.03),
      borderColor: alpha('#000000', 0.2)
    }
  },

  submitButton: {
    flex: 1,
    padding: '11px 20px',
    backgroundColor: softColors.primary,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.9)
    }
  },

  editFormButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '12px',
    marginTop: '24px',
    paddingTop: '20px',
    borderTop: `1px solid ${alpha(softColors.border, 0.3)}`
  },

  updateButton: {
    padding: '11px 24px',
    backgroundColor: softColors.primary,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.9)
    }
  },

  editCancelButton: {
    padding: '11px 24px',
    backgroundColor: '#ffffff',
    color: '#666666',
    border: `1px solid ${alpha('#000000', 0.12)}`,
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor: alpha('#000000', 0.03),
      borderColor: alpha('#000000', 0.2)
    }
  }
};